import { correct } from "./correct";
import { dont_understand } from "./dont_understand";
import { incorrect } from "./incorrect";
import { recording } from "./recording";
import { sent_to_server } from "./sent_to_server";
import { sleeping } from "./sleeping";
import { speaking_1 } from "./speaking_1";
import { speaking_2 } from "./speaking_2";
import { waiting } from "./waiting";
import { wake_up } from "./wake_up";
import { what_we_gonna_do } from "./what_we_gonna_do";

debugger;

export const animations_15_fps: Record<string, string[]> = {
  correct,
  dont_understand,
  incorrect,
  recording,
  sent_to_server,
  sleeping,
  speaking_1,
  speaking_2,
  waiting,
  wake_up,
  what_we_gonna_do,
};

console.log(animations_15_fps)
